module.exports = __webpack_public_path__ + "img/success-dark.ed4f70ac.svg";